import { useMemo } from 'react';
import {
  dashboardIdAtom,
  isSavedDashboardAtom,
  isSharingAtom,
  pageKeyAtom,
} from '@src/atoms/pageMeta';

export function usePageMeta({ id, store }) {
  const isSavedDashboard = store.get(isSavedDashboardAtom);
  const isSharing = store.get(isSharingAtom);

  const pageKey = useMemo(() => {
    if (isSavedDashboard && id) {
      return id;
    } else if (isSharing && id) {
      return `sharing-${id}`;
    }
    return id;
  }, [id, isSavedDashboard, isSharing]);

  useMemo(() => {
    if (store) {
      store.set(pageKeyAtom, pageKey);
      store.set(dashboardIdAtom, id);
    }
  }, [pageKey, id]);

  return { pageKey };
}

export default usePageMeta;
